<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import StatutoryReportForm from "../../../components/payroll/statutoryreportsetup/FormNew";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": StatutoryReportForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupbaitulmal.newstatutorysetup'),
      pageTitleValue: "",
      formData: {
        id: null,
        startdate: null,
        enddate: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      statutoryDetail: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {
        url: "/statutoryreportsetup/createNew",
        payload: this.formData
      })
      .then((res) => {
        if (res.data.error) {
          this.isErr = true;
          this.errMsg = res.data.error;   // ✅ always a string now
        } else {
          this.$router.push({
            name: 'statutoryreportsetupedit_new',
            params: { id: res.data.id }
          });
        }
      })
      .catch((err) => {
        console.log("DB error:", err);
        this.isErr = true;
        this.errMsg = err.response?.data?.error || err.message;
      });
    },

    cancelHandler() {
      this.$router.push({ name: "statutoryreportsetuplist" });
    },
  },
};
</script>